import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const UserLoginIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="-1 0 24 24"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <path
        d="M20.1398 17.9381C19.6148 16.7662 18.8648 15.7162 17.9086 14.8162C16.957 13.9186 15.8508 13.2154 14.618 12.7232C14.3602 12.6201 14.1 12.5287 13.8352 12.4467C14.1328 12.2428 14.4117 12.0107 14.6719 11.7506C15.7758 10.6467 16.3828 9.18184 16.3828 7.6209C16.3828 6.0623 15.7758 4.59512 14.6719 3.49121C13.568 2.3873 12.1031 1.78027 10.5422 1.78027C8.98125 1.78027 7.51641 2.3873 6.4125 3.49121C5.30859 4.59512 4.70156 6.05996 4.70156 7.6209C4.70156 9.17949 5.30859 10.6467 6.4125 11.7506C6.66562 12.0037 6.93516 12.2287 7.22344 12.4279C6.93984 12.5146 6.65859 12.6131 6.37969 12.7232C5.14687 13.2154 4.04062 13.9186 3.08906 14.8162C2.13281 15.7162 1.38281 16.7662 0.857812 17.9381C0.311719 19.1545 0.0351562 20.4459 0.0351562 21.7795C0.0351562 22.2975 0.454687 22.717 0.972656 22.717C1.49062 22.717 1.91016 22.2975 1.91016 21.7795C1.91016 17.399 5.71641 13.8342 10.3922 13.8342H10.6008C15.2789 13.8342 19.0828 17.399 19.0828 21.7795C19.0828 22.2975 19.5023 22.717 20.0203 22.717C20.5383 22.717 20.9578 22.2975 20.9578 21.7795C20.9625 20.4482 20.6859 19.1545 20.1398 17.9381ZM10.5445 3.65762C12.7312 3.65762 14.5078 5.43652 14.5078 7.6209C14.5078 9.80527 12.7289 11.5842 10.5445 11.5842C8.36016 11.5842 6.58125 9.80527 6.58125 7.6209C6.58125 5.43652 8.35781 3.65762 10.5445 3.65762Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default memo(UserLoginIcon);
